var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_521_810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 19.9999C20.0002 22.2093 18.2096 23.9999 16.0002 23.9999H8.00024C5.79086 23.9999 4.00024 22.2093 4.00024 19.9999V8.5332H20.0002V19.9999ZM9.33358 11.9999C8.81795 11.9999 8.40024 12.4176 8.40024 12.9332V19.5999C8.40024 20.1155 8.81795 20.5332 9.33358 20.5332C9.8492 20.5332 10.2669 20.1155 10.2669 19.5999V12.9332C10.2669 12.4176 9.8492 11.9999 9.33358 11.9999ZM14.6669 11.9999C14.1513 11.9999 13.7336 12.4176 13.7336 12.9332V19.5999C13.7336 20.1155 14.1513 20.5332 14.6669 20.5332C15.1825 20.5332 15.6002 20.1155 15.6002 19.5999V12.9332C15.6002 12.4176 15.1825 11.9999 14.6669 11.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 0C15.5429 0 17.3335 1.79061 17.3335 4V4.26667H20.5335C21.27 4.26667 21.8669 4.86355 21.8669 5.6C21.8669 6.33645 21.27 6.93333 20.5335 6.93333H3.46688C2.73042 6.93333 2.13354 6.33645 2.13354 5.6C2.13354 4.86355 2.73042 4.26667 3.46688 4.26667H6.66688V4C6.66688 1.79061 8.45749 0 10.6669 0H13.3335ZM10.6669 2.66667C9.93043 2.66667 9.33355 3.26355 9.33355 4V4.26667H14.6669V4C14.6669 3.26355 14.07 2.66667 13.3335 2.66667H10.6669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_521_810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.12ea4c348b9554c8e767f13528820fa9.svg";
export { ForwardRef as ReactComponent };